import { StopAutoRenewalCode } from './checkout-request.types';

export interface UpdateAutoRenewalContext {
  contactUsCategory: string;
  planNumber: string;
  action: StopAutoRenewalCode;
  client?: string;
}

export interface UpdateAutoRenewalRequest {
  data: {
    context: UpdateAutoRenewalContext;
  };
}
